import responseToInvitationsList from "./responseToInvitations";
import timeInPeerReview from "./timeInPeerReview";

export default [...responseToInvitationsList, ...timeInPeerReview];
